import createAuthAxios from 'common/lib/createAuthAxios';
import { CHAT_EVENT_TYPES } from 'common/components/CopyMagic/constants';
import copyMagicLog from 'common/components/CopyMagic/shared/copyMagicLog';

type PostChatEventRequest = {
  sessionId: string;
  eventType: (typeof CHAT_EVENT_TYPES)[keyof typeof CHAT_EVENT_TYPES];
  sentAt?: string;
};

const postChatEvent = async ({
  sessionId,
  eventType,
  sentAt = new Date().toISOString(),
}: PostChatEventRequest) => {
  const authAxios = createAuthAxios();

  const url = `/api/admin/copy_magic/chat_events`;
  const params = {
    session_id: sessionId,
    event_type: eventType,
    sent_at: sentAt,
  };

  try {
    await authAxios.post(url, params);
  } catch (error) {
    copyMagicLog(error, { level: 'error' });
  }
};

export default postChatEvent;
